var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    width: 600,
    height: 600,
    viewBox: "0 0 960 336",
    sodipodiDocname: "Gestion-Le-Loup-Logo.ai",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,252 H 720 V 0 H 0 Z",
    id: "path26"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g24",
    clipPath: "url(#clipPath28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g64",
    transform: "translate(76.6976,145.4553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.522,1.312 -1.023,2.584 -1.532,3.826 -1.188,-3.813 -3.25,-6.613 -5.136,-10.193 -2.159,5.932 -3.419,12.802 -1.371,19.857 -4.962,-3.3 -6.857,-8.306 -7.927,-11.588 -4.265,7.629 -3.758,17.549 0.155,24.969 C -7.167,18.988 1.446,16.462 11.669,13.874 7.975,10.943 3.026,6.178 0,0 m 132.141,25.01 c 0.306,5.261 -5.174,10.38 -11.185,10.735 -1.926,0.118 -6.305,-0.558 -11.179,-2.156 -7.344,-2.453 -15.969,-4.74 -23.959,-5.614 -9.568,-1.054 -18.73,0.134 -30.024,8.043 -50.693,-24.321 -40.96,-3.615 -79.253,0.943 -8.207,-21.64 -2.268,-41.672 17.037,-48.979 -7.721,-8.425 -11.646,-21.354 -11.646,-21.354 2.746,2.171 7.695,5.076 12.982,7.653 -2.93,-6.541 -12.633,-24.071 -8.093,-43.87 3.657,11.35 11.281,19.421 11.281,19.421 -15.064,-32.537 3.348,-57.381 3.348,-57.381 -2.018,21.565 3.027,31.295 3.027,31.295 l 16.773,-41.762 c 0.882,51.075 22.897,66.494 31.654,70.622 -15.69,0.894 -32.715,-10.557 -37.408,-26.29 -10.255,11.432 -4.216,37.112 13.381,43.945 -3.08,-3.106 -5.593,-9.231 -5.671,-13.461 15.78,10.94 37.806,-2.891 56.244,11.309 -8.147,-2.822 -19.124,1.774 -28.154,4.353 3.273,1.457 6.967,2.76 10.446,3.66 -12.167,5.435 -29.984,8.065 -42.277,4.567 7.865,6.49 17.495,9.852 17.495,9.852 -14.782,11.164 -11.471,21.014 4.292,28.404 3.528,1.65 7.252,2.945 9.696,3.011 1.909,0.053 4.177,-0.263 7.976,-0.684 7.104,-0.832 12.579,-1.2 17.239,-1.169 -4.396,-2.365 -8.981,-4.81 -10.534,-5.595 -2.413,-1.238 -6.414,-0.361 -10.165,0.345 -5.432,0.987 -9.35,-0.983 -13.768,-3.774 0,0 4.726,-1.715 7.797,-2.825 4.655,-1.728 10.324,-2.815 17.339,1.858 5.238,3.453 11.955,7.315 17.759,10.54 9.147,1.208 16.798,4.271 33.282,8.367 3.649,0.917 5.83,-0.403 7.296,-3.878 -1.461,1.048 -5.524,1.478 -8.683,1.118 -6.59,-0.742 -4.878,-7.775 -3.338,-8.547 1.664,-0.807 2.343,3.317 3.791,2.571 1.448,-0.745 -0.262,-4.664 0.676,-5.773 1.87,-2.213 7.42,2.709 7.262,-0.844 -0.373,-8.378 -13.911,-21.593 -14.214,-21.839 -4.26,1.483 -15.734,2.031 -23.403,-0.628 0,0 2.204,-0.937 2.911,-2.534 0.728,-1.637 2.023,-4.431 3.032,-4.155 0.601,0.127 7.593,2.306 16.971,-1.525 2.475,-1.011 2.198,-5.212 2.198,-5.212 0,0 -1.553,1.54 -6.801,2.939 -5.238,1.43 -7.441,-0.698 -7.441,-0.698 0,0 5.156,-1.14 7.661,-2.255 2.497,-1.144 4.41,-4.913 0.401,-10.577 -1.049,-1.462 -4.341,-2.97 -5.495,-3.452 -10.483,-4.379 -26.428,-8.05 -35.863,-17.036 -0.58,3.054 1.69,7.005 1.69,7.005 -3.952,-1.513 -9.164,-12.443 -9.164,-12.443 -0.841,3.376 0.588,9.419 0.588,9.419 -6.659,-4.359 -9.864,-17.651 -11.083,-21.061 -1.102,8.354 2.135,17.129 2.135,17.129 -19.664,-19.299 -10.028,-45.536 9.808,-58.78 3.255,-3.102 7.516,-5.919 12.944,-8.34 -5.036,31.566 3.342,66.688 35.261,80.083 1.74,0.73 3.369,1.329 4.584,2.676 4.023,4.432 7.225,10.527 6.676,14.537 -0.377,2.632 -2.203,8.8 -3.261,12.192 2.158,2.672 8.389,9.672 10.537,12.702 4.137,5.838 6.246,17.915 6.592,23.197",
    style: {
      fill: "#ffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g68",
    transform: "translate(177.1508,223.1631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 51.505,-14.709 81.354,-68.377 66.636,-119.913 -12.069,-42.26 -50.394,-69.914 -92.179,-70.371 35.34,4.523 66.32,29.491 76.723,65.916 13.937,48.803 -14.323,99.658 -63.126,113.596 -36.456,10.411 -74.019,-2.712 -96.523,-30.333 C -86.005,-5.832 -42.291,12.078 0,0",
    style: {
      fill: "#ffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path70"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullLogo);
export default __webpack_public_path__ + "static/media/full_logo.861a3541740609837c5cfec94bc6f011.svg";
export { ForwardRef as ReactComponent };